import React, {Component} from 'react'
import qs from 'qs'
import {get} from 'lodash'
import {withRouter} from 'react-router-dom'
import {
  Button,
  Radio,
  Card,
  CardContent,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Typography,
} from '@material-ui/core'

import {FuseAnimate} from '@fuse'

import {facebookService} from '../../../../facebook'

import {requireAuthAndProject} from '../../../../auth'

class FacebookPageConnectHandler extends Component {
  state = {
    selectedValue: '0',
    pages: null,
    loading: true,
  }

  async componentDidMount() {
    const queryString = (this.props.location.search || this.props.location.hash)
      .replace('?', '')
      .replace('#', '')
    const query = qs.parse(queryString)
    facebookService.accessToken = query.access_token
    await facebookService.requestLongLiveToken()
    const pages = await facebookService.getPageList()
    this.setState({
      loading: false,
      pages,
    })
  }

  handleRadioChange = e => {
    this.setState({
      selectedValue: e.target.value.toString(),
    })
  }

  onConnect = async () => {
    const {pages, selectedValue} = this.state
    const selectedPage = pages.data[+selectedValue]
    const projectId = get(this.props, 'match.params.projectId')
    await facebookService.subscribeApp(selectedPage, projectId)
  }

  render() {
    if (this.state.loading) {
      return (
        <Typography variant="title" className="mt-16 mb-32">
          Loading...
        </Typography>
      )
    }

    return (
      <FuseAnimate animation="transition.expandIn">
        <Card>
          <CardContent className="flex flex-col justify-center p-32">
            <Typography variant="title" className="mt-16 mb-32">
              Connect your facebook page with Deeple
            </Typography>
            <FormLabel component="legend">Pages</FormLabel>
            <RadioGroup
              aria-label="Pages"
              name="pages"
              value={this.state.selectedValue}
              onChange={this.handleRadioChange}
            >
              {this.state.pages.data.map((page, index) => (
                <FormControlLabel
                  key={page.id}
                  value={index.toString()}
                  control={<Radio />}
                  label={page.name}
                />
              ))}
            </RadioGroup>
            <Button
              variant="raised"
              color="primary"
              className="w-224 mt-16"
              aria-label="LOG IN"
              onClick={this.onConnect}
            >
              Connect
            </Button>
          </CardContent>
        </Card>
      </FuseAnimate>
    )
  }
}

export default requireAuthAndProject(withRouter(FacebookPageConnectHandler))



// WEBPACK FOOTER //
// ./src/main/content/project/connect/Connect.js